export default {
  'global#home': 'Home',
  'global#works': 'Opere',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Spiacenti, si è verificato un errore',
  'global#layout_error_description': 'Prova a ricaricare la pagina tra qualche istante e se il problema persiste contatta l\'amministratore della piattaforma.',
  'global#facet_empty_text': 'Nessun risultato',
  'readmore#label': 'Mostra tutto',
  'search#editions_title': 'Edizioni Digitali',
  'search#works_title': 'Mapping Chivalry <br>Progetto Mambrino Database Bibliografico (PMDB)',
  'search#works_total': '<strong>{ total }</strong> Opere',
  'search#news_total': '<strong>{ total }</strong> News',
  'search#news_total_0': 'No News',
  'search#works_total_1': '<strong>{ total }</strong> Opera',
  'search#characters_total': '<strong>{ total }</strong> Personaggi',
  'search#characters_total_1': '<strong>{ total }</strong> Personaggio',
  'search#motifs_title': 'Indice dei Motivi',
  'search#places_total_0': 'Nessun Luogo',
  'search#motifs_total': '<strong>{ total }</strong> Motivi',
  'search#motifs_total_1': '<strong>{ total }</strong> Motivo',
  'search#motifs_total_0': 'Nessun Motivo',
  'search#places_total': '<strong>{ total }</strong> Luoghi',
  'search#places_total_1': '<strong>{ total }</strong> Luogo',
  'search#works_total_0': 'Nessuna Opera',
  'search#books_total': '<strong>{ total }</strong> Libri',
  'search#books_total_1': '<strong>{ total }</strong> Libro',
  'search#books_total_0': 'Nessun Libro',
  'search#placeholder_query': 'Cerca nei titoli',
  'search#character_placeholder_query': 'Cerca nei nomi',
  'search#resultsamount': 'Mostra risultati',
  'search#header_authors': 'Autori',
  'search#header_languages': 'Lingua',
  'search#characters_title': 'Indice dei Personaggi',
  'search#places_title': 'Indice dei Luoghi',
  'search#header_subjects': 'Soggetti',
  'search#header_traits': 'Tratti',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Opere',
  'search#header_libraries': 'Biblioteca',
  'search#header_motif_type': 'Tipologie',
  'search#header_romances': 'Cicli',
  'search#header_cycles': 'Cicli',
  'search#header_cities': 'Città',
  'search#header_dates': 'Date',
  'search#header_curators': 'Curatori',
  'search#header_forenames': 'Nomi',
  'search#header_in_works': 'Opere di apparizione',
  'search#header_translators': 'Traduttori',
  'search#facets_title': 'Filtra i risultati',
  'search#filters_title': 'Filtri attivi:',
  'advancedsearch#filters_title': 'Filtri attivi:',
  'search#sort_title': 'Ordine',
  'search#sort_label_ciclo': 'Ordine per posizione nel ciclo',
  'search#sort_score': 'Ordine per pertinenza',
  'search#sort_asc': 'Ordine alfabetico (A→Z)',
  'search#sort_desc': 'Ordine alfabetico (Z→A)',
  'search#sort_data_desc': 'Più recente',
  'search#sort_section_asc': 'Ordina per sezione (Opere - Edizioni)',
  'search#sort_section_desc': 'Ordina per sezione (Edizioni - Opere)',
  'search#fallback_text': 'La tua ricerca non ha dato risultati. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#fallback_button': 'Resetta la ricerca',
  'search#ko_text': 'Oops, abbiamo riscontrato un errore nella ricerca. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#ko_button': 'Resetta la ricerca',
  'search#description_button': 'Info',
  'search#description_link': 'Ok, ho capito',
  'search#redirect_link': 'Ricerca avanzata',
  'resource#authors': 'di',
  'resource#date': 'pubblicato il',
  'resource#time_to_read': 'lettura di',
  'resource#metadata': 'Metadati',
  'resource#complete-title': 'Titolo completo',
  'resource#collection-sources': 'Fonti collegate',
  'resource#collection-editions': 'Edizioni collegate',
  'resource#collection-samples': 'Esemplari',
  'resource#collection-translations': 'Traduzioni collegate',
  'resource#collection-digital-editions': 'Edizioni digitali',
  'resource#collection-text': 'Edizione digitale',
  'resource#collection-antroponimi': 'Antroponimi collegati',
  'resource#collection-toponimi': 'Toponimi collegati',
  'resource#parent-record': 'Opera di riferimento',
  'resource#parent-edition': 'Edizione',
  'resource#occurences': 'Occorrenze',
  'resource#metadata_size': 'Dimensioni',
  'search#header_genres': 'Genere',
  'search#header_language': 'Lingua',
  'resource#collection-rewritings': 'Riscritture',
  'search#date': 'data',
  'search#bibliographies_total': '<strong>{ total }</strong> riferimenti bibliografici',
  'search#bibliographies_total_1': '<strong>{ total }</strong> riferimento bibliografico',
  'search#bibliographies_total_0': 'Nessun riferimento bibliografico',
  'search#placeholder_authors': 'Cerca un autore',
  'search#title_bibliographies': 'Bibliografia',
  'search#biographies_total': '<strong>{ total }</strong> vite antiche',
  'search#biographies_total_1': '<strong>{ total }</strong> vita antica',
  'search#biographies_total_0': 'Nessuna vita antica',
  'search#title_biographies': 'Vite antiche',
  'search#iconographies_total': '<strong>{ total }</strong> iconografie',
  'search#iconographies_total_1': '<strong>{ total }</strong> iconografia',
  'search#iconographies_total_0': 'Nessuna iconografia',
  'search#title_iconographies': 'Vite antiche',
  'search#header_sex': 'Sesso',
  'search#tools_total': '<strong>{ total }</strong> materiali e strumenti',
  'search#tools_total_1': '<strong>{ total }</strong> materiale e strumento',
  'search#tools_total_0': 'Nessun materiale e strumento',
  'search#title_tools': 'Materiali e strumenti',
  'search#motif_placeholder_query': 'Cerca motivo',
  'readmore#more': 'Mostra tutto',
  'readmore#less': 'Mostra meno',
  'advancedsearch#works_total': '<strong>{ total }</strong> Risultati',
  'advancedsearch#works_total_1': '<strong>{ total }</strong> Risultato',
  'advancedsearch#works_total_0': 'Nessun Risultato',
  'advancedsearch#search_in_title': 'Cerca in:',
  'advancedsearch#label_title': 'Titolo',
  'advancedsearch#label_work_title': "Seleziona un'opera",
  'advancedsearch#label_work_title_info':
    'Seleziona il titolo dell’opera in cui desideri effettuare la ricerca. Non indicare alcuna voce se intendi cercare in tutte le opere',
  'advancedsearch#label_resource_type': 'Tipo di risorsa',
  'advancedsearch#label_text': 'Cerca nei testi',
  'advancedsearch#label_search_title': 'Ricerca nei testi',
  'advancedsearch#label_content': 'Contenuti',
  'advancedsearch#intro':
    'In questa sezione è possibile interrogare, in modo semplice o incrociato, i dati presenti nel portale.\n“Cerca del portale” permette di estrarre, attraverso una ricerca generale, risultati dalle varie sezioni che possono essere interrogate singolarmente o in modo simultaneo.\n“Cerca nelle opere” consente una ricerca testuale, per lemma e/o per voce di autorità, all’interno delle opere di Petrarca e delle biografie antiche a lui dedicate.',
  'advancedsearch#search_portal': 'Cerca nel portale',
  'advancedsearch#fulltext_text': 'Cerca nel portale (in tutti i campi)',
  'advancedsearch#section_work': 'Cerca nelle opere',
  'advancedsearch#section_edition': 'Cerca nelle edizioni',
  'advancedsearch#section_sample': 'Cerca negli esemplari',
  'advancedsearch#label_works': 'Opere',
  'advancedsearch#label_editions': 'Edizioni',
  'advancedsearch#label_samples': 'Esemplari',
  'advancedsearch#label_translator': 'Traduttore',
  'advancedsearch#label_place': 'Luogo di edizione',
  'advancedsearch#label_cycle': 'Ciclo',
  'advancedsearch#label_subject': 'Soggetto',
  'advancedsearch#language': 'Lingua',
  'advancedsearch#label_editor': 'Editore',
  'advancedsearch#label_dedica': 'Dedicatario',
  'advancedsearch#label_year': 'Data',
  'advancedsearch#label_editorial-mark': 'Marca editoriale',
  'advancedsearch#label_id_pmdb': 'ID PMDB',
  'advancedsearch#marginalia_label': 'Marginalia',
  'advancedsearch#reproduction_label': 'Riproduzione fotografica',
  'advancedsearch#digital_edition_label': 'Edizione digitale',
  'advancedsearch#value_exists': 'Sì',
  'advancedsearch#value_not_exists': 'No',
  'advancedsearch#label_library_city': 'Città biblioteca',
  'advancedsearch#label_library': 'Biblioteca',
  'advancedsearch#label_note': 'Descrizione e note',
  'advancedsearch#label_previous_owner': 'Proprietari precedenti',
  'advancedsearch#fulltext_info':
    'Cerca un termine in tutte le sezioni del portale.',
  'advancedsearch#section_info':
    'Indica la sezione o le sezioni in cui desideri effettuare la ricerca',
  'advancedsearch#label_textual': 'Ricerca testuale',
  'advancedsearch#library_text': 'Biblioteca',
  'advancedsearch#label_signature': 'Segnatura',
  'advancedsearch#section_global': 'Cerca nel portale',
  'advancedsearch#label_type': 'cerca in:',
  'advancedsearch#advanced_search': 'Ricerca avanzata',
  'advancedsearch#section_textual': 'Cerca nelle opere',
  'advancedsearch#label_manuscript_content': 'Contenuti dei manoscritti',
  'advancedsearch#text_info':
    'Effettuando un’interrogazione per lemma, puoi ricorrere a caratteri speciali per affinarla: * corrisponde a un numero qualsiasi di caratteri ed è possibile usarlo in qualsiasi posizione in una stringa di caratteri; ? corrisponde a un singolo carattere alfabetico in una posizione specifica di una stringa.\nUna volta avviata la ricerca, selezionando i singoli risultati ottenuti verrai indirizzato nella sezione dell’opera in cui l’occorrenza è presente; per raggiungere l’esatta porzione di testo interessata puoi poi scorrere il testo o, in alternativa, effettuare una ricerca veloce attraverso il comando CTRL+F',
  'advancedsearch#include_authority': 'Voci di autorità',
  'advancedsearch#text_title': 'cerca per lemma',
  'advancedsearch#highlights_title': 'Risultati',
  'advancedsearch#reset': 'Pulisci campi',
  'advancedsearch#submit': 'Cerca',
  'advancedsearch#label_author': 'Autore',
  'author.name': 'Autore',
  'advancedsearch#label_edition': 'Dati editoriali',
  'advancedsearch#label_date': 'Data',
  'advancedsearch#language_esp': 'spagnolo',
  'advancedsearch#language_ita': 'italiano'
};
